import React from 'react'; 
import {getData } from '../../../core/HttpAction';  
import Table from '../../../core/Table'; 
import {PdfGenrate} from '../../../core/Pdf'; 
import Filter from '../../Student/Student/Filter';


const Url='/student-fees-detail';
const ActionColumn=({props,index})=>{   
    return <span>
        <i title='Export CSV' onClick={()=>{
            props.callPrint(index)
            ; 
        }} className="md-icon material-icons md-24">archive</i>
        <i title='download' onClick={()=>{
            props.callPrint(index,true)
            ; 
        }} className="md-icon material-icons md-24">printer</i>
    </span>;
}; 

const QuotaColumn=({row})=>{   
    return row.course_quota=='1'?'Management':'Government';
};
const GraduationColumn=({row})=>{   
    return row.graduation=='1'?'Yes':'No';
};
const OtherColumn=({row})=>{   
    return row.other_scholarship=='1'?'Yes':'No';
};
const GetSem=({row})=>{   
    return  row.feesData[0].feesData[0]['courseYearSemester'];
};



const columns=[
  
    {
        key:'name',
        displayName:'Student Name'
    },
    {
        key:'id_no',
        displayName:'ID'
    },
    {
        key:'course_name',
        displayName:'Course'
    },
    {
        key:'year_name',
        displayName:'Year'
    },
    {
        key:'semester_name',
        displayName:'Semester',
        Cell:GetSem  
    },
    {
        key:'graduation',
        displayName:'Graduation',
        Cell:GraduationColumn  
    },
    {
        key:'other_scholarship',
        displayName:'Other Scholarship',
        Cell:OtherColumn 
    },
    {
        key:'course_quota',
        displayName:'Quota',
        Cell:QuotaColumn 
    },
    {
        key:'year_name',
        displayName:'Action',
        Cell:ActionColumn
    },
];
 
class Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            params:{
                search_term: '',
                startDate: '',
                endDate:'',   
                course_id:'',
                course_quota:'',
                course_year_id:'',
                other_scholarship:'',
                graduation:'', 
            }, 
            data:[],
            preloader:true
        }; 
    }
 
    componentDidMount(){
        this.fetchData();
    }

 
    fetchData=()=>{
        getData(Url,this.state.params).then((res)=>{ 
            this.setState({data:res.data,preloader:false}); 
        });
    }

    handleFetch(params){
        this.setState({params:{...this.state.params,...params},preloader:true},()=>{
            this.fetchData();
        });
    }
 
    callPrint=(i,printer)=>{
        const pdfArray=[
            {
                index:'right-left-column-table',
                data:document.getElementById('pdfContent'+i)
            },
            {
                index:'table',
                data:document.getElementById('pdfContentData'+i),
            },
            /* {
                index:'right-column-data',
                data:document.getElementById('pdfContentPaymentData'+i)
            } */
        ]; 
        if(printer)
            PdfGenrate({pdfArray,filename:'student-fees-report',printer:true}); 
        else
            PdfGenrate({pdfArray,filename:'student-fees-report'}); 
    }

    custonAction=(data)=> {  
        this.setState({params:{...this.state.params,...data},preloader:true},()=>{
            this.fetchData();
        }); 
    }


    render() {
        let {preloader,data}=this.state;
        let dataVal='';
        let paid_amount=0;
        let due_amount=0;
        return ( 
            <div> 
                <Table
                    data={data}
                    handleFetch={this.handleFetch}
                    preloader={preloader}
                    permission="student-fees-report"
                    title="Student Fees Report"
                    columns={columns}
                    primaryKey="student_id"
                    callPrint={this.callPrint}
                    custonAction={this.custonAction}
                    CustomFilters={ Filter }
                /> 

                { 
                    data.data && data.data.map((vals,i)=>{ 
                        dataVal=vals.feesData[0];
                        return(
                            <div style={{display:'none'}} key={i}>
                                <table id={`pdfContent${i}`} >
                                    <tr>  
                                        <td>Student ID </td>
                                        <td>: {vals.id_no}</td> 
                                        <td>Course</td>
                                        <td>: {vals.course_name}</td>
                                    </tr> 
                                    <tr>  
                                        <td>Student Name </td>
                                        <td>: {vals.name}</td>                                        
                                        <td>Year(Semester)</td>
                                        <td>: { `${vals.year_name} (${dataVal.feesData[0]['courseYearSemester']})` }</td>
                                    </tr>
                                    <tr>  
                                        <td>Bill Date </td>
                                        <td>: {dataVal.feeDate}</td> 
                                        <td>Quota</td>
                                        <td>: {vals.course_quota=='1' ? 'Management':'Government'}</td>
                                    </tr> 

                                    {/* <tr>  
                                        <td>Admission Date </td>
                                        <td>: {vals.joining_date}</td> 
                                        <td>Hosteler </td>
                                        <td>: {vals.hosteler?'Yes':'No'}</td>
                                    </tr>
                                    <tr>  
                                        <td>Gender </td>
                                        <td>: {vals.gender?'Male':'Female'}</td> 
                                        <td>Mobile No1 </td>
                                        <td>: {vals.mobile}</td>
                                    </tr>
                                    <tr>  
                                        <td>Date Of Birth </td>
                                        <td>: {vals.dob}</td> 
                                        <td>Mobile No2 </td>
                                        <td>: {vals.phone}</td>
                                                
                                    </tr>
                                    <tr>  
                                        <td>Father Name </td>
                                        <td>: {vals.father_name}</td> 
                                        <td>Fees Structure Name </td>
                                        <td>: {dataVal.fees_structure_name}</td>
                                    </tr> 
                                    <tr>  
                                        <td>Bill Date </td>
                                        <td>: {dataVal.feeDate}</td> 
                                        <td>Quota</td>
                                        <td>: {vals.course_quota ? 'Management':'Government'}</td>
                                    </tr>  */}
                                </table>
                                            
                                <table id={`pdfContentData${i}`} >
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Particulars</th>
                                            <th>Amount</th>  
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { 
                                            dataVal.feesData && dataVal.feesData.map((val,k)=>{ 
                                                paid_amount=0;
                                                due_amount=0;
                                                paid_amount=parseFloat(dataVal.cash)+parseFloat(dataVal.dd_amount)+parseFloat(dataVal.dd_rtgs)+parseFloat(dataVal.neft_amount); 

                                                due_amount=parseFloat(dataVal.bill_amount)-parseFloat(paid_amount);

                                                return( 
                                                    <tr key={k}>
                                                        <td>{parseInt(k)+1}</td>
                                                        <td>{val.feesType}</td>
                                                        <td> { parseFloat(vals.course_quota=='0'?val.gq_amount:val.mq_amount).toFixed(2)}</td>  
                                                    </tr> 
                                                );
                                            })
                                        }
                                        <tr>
                                            <th></th>
                                            <th>Billed Amount</th>
                                            <th>{parseFloat(dataVal.bill_amount).toFixed(2)}</th>  
                                        </tr>
                                        <tr>
                                            <th></th>
                                            <th>Paid Amount</th>
                                            <th>{parseFloat(paid_amount).toFixed(2)}</th>  
                                        </tr>
                                        <tr>
                                            <th></th>
                                            <th>Due Amount</th>
                                            <th>{ due_amount>0?parseFloat(due_amount).toFixed(2):'0.00'}</th>  
                                        </tr>
                                        <tr>
                                            <th></th>
                                            <th>Excess Amount</th>
                                            <th>{parseFloat(dataVal.excess_amount).toFixed(2)}</th>  
                                        </tr>
                                    </tbody> 
                                </table> 

                                <table id={`pdfContentPaymentData${i}`} >
                                    <thead>
                                        <tr>
                                            <th>Payment Detail</th>
                                            <th>Amount</th>  
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { dataVal.cash&&
                                                <tr>
                                                    <th>Cash</th>
                                                    <th>{parseFloat(dataVal.cash).toFixed(2)}</th>  
                                                </tr>
                                        }
                                        { dataVal.dd_amount&&
                                                <tr>
                                                    <th>DD Amount</th>
                                                    <th>{parseFloat(dataVal.dd_amount).toFixed(2)}</th>  
                                                </tr>
                                        }
                                        {dataVal.dd_rtgs&&
                                                <tr>
                                                    <th>RTGS Amount</th>
                                                    <th>{parseFloat(dataVal.dd_rtgs).toFixed(2)}</th>  
                                                </tr>
                                        }
                                        {dataVal.fg_scholar_amount &&
                                                <tr>
                                                    <th>First Graduate Amount</th>
                                                    <th>{parseFloat(dataVal.fg_scholar_amount).toFixed(2)}</th>  
                                                </tr>
                                        }
                                        { dataVal.other_scholar_amount&&
                                                    <tr>
                                                        <th>Other ScholarShip Amount</th>
                                                        <th>{parseFloat(dataVal.other_scholar_amount).toFixed(2)}</th>  
                                                    </tr>
                                        }
                                        <tr>
                                            <th>Total Paid Amount</th>
                                            <th>{parseFloat(parseFloat(dataVal.bill_amount)+parseFloat(dataVal.excess_amount)-parseFloat(dataVal.balance_amount)).toFixed(2)}</th>  
                                        </tr>
                                        <tr>
                                            <th>Balance Amount</th>
                                            <th>{parseFloat(dataVal.excess_amount).toFixed(2)}</th>  
                                        </tr>
                                        <tr>
                                            <th>Due Amount</th>
                                            <th>{parseFloat(dataVal.balance_amount).toFixed(2)}</th>  
                                        </tr>
                                    </tbody>
                                </table>
                                        
                            </div>);
                    })
                } 

   
            </div>
        );
    }
}
export default Reports;


// WEBPACK FOOTER //
// ./src/components/Reports/StudentReport/studentFeesReport.js